import { DataBean } from "../DataBean";

export class BusinessProcess extends DataBean {

    public async requestBusinessProcessByIDAdquisitionItem(idAdquisitionItem: number, idEmployee: number, obs: string, code: string, phaseState: number): Promise<any> {
        return this.getCustomService("SupplierERP", "com.orange.bean.ItemFlow_requestBusinessProcessByIDAdquisitionItem_Number_Number_String_String_Number", [idAdquisitionItem, idEmployee, obs, code, phaseState]);
    }

    public async requestBusinessProcess(idEmployee: number, obs: string, code: string, varName: string, varValue: number, jSONProps: string, externalCode: string): Promise<any> {
        return this.getCustomService(
            "SupplierERP",
            "com.orange.bean.RequestProcessBpm_requestBusinessProcess_Number_String_String_String_Number_String_String",
            [idEmployee, obs, code, varName, varValue, jSONProps, externalCode]);
    }

}